import { Popover, Tag } from "antd";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import styles from "./UnitCard.module.scss";

const UnitCard = ({
  unit,
  landscape,
  setSelectedUnitId,
  setSelectedUnit,
  selectedUnitQueue,
  setSelectedUnitQueue,
  setUnitSearchFilter,
  setSection,
}) => {
  const level_colors = ["magenta", "green", "cyan", "gold"];

  const onClickUnit = (unitName, unitId) => {
    setSelectedUnit(unitName);
    setSelectedUnitId(unitId);
    setSelectedUnitQueue([...selectedUnitQueue, unit]);
    setUnitSearchFilter({
      query: null,
    });
  };
  const onGetInformation = (unitName, unitId) => {
    setSelectedUnit(unitName);
    setSelectedUnitId(unitId);
    setSelectedUnitQueue([...selectedUnitQueue, unit]);
    setUnitSearchFilter({
      query: null,
    });
    setSection(1);
  };
  return (
    <div
      className={
        landscape ? styles["unit"] : `${styles["unit"]} ${styles["border"]}`
      }
    >
      <div
        className={styles["general-information"]}
        onClick={() => onClickUnit(unit.name, unit.id)}
      >
        <p
          className={styles["name"]}
          // onClick={() => onClickUnit(unit.name, unit.id)}
        >
          {unit.name}
        </p>
        <p className={styles["bio"]}>{unit.bio}</p>
        <div className={styles["statistic"]}>
          {IconPack.unit_faculty_members}
          <p>
            <span>{numberRegex(unit.total_faculties)}</span> Faculty Members
          </p>
        </div>
        <div className={styles["statistic"]}>
          {IconPack.unit_publications}
          <p>
            <span>{numberRegex(unit.total_publication)}</span> Publications
          </p>
        </div>
        <div>
          {unit.level && (
            <Tag color={level_colors[unit.level - 1]}>Level {unit.level}</Tag>
          )}
        </div>
        <div>
          {unit.keywords?.map((key, index) => {
            return <Tag key={index}>{key}</Tag>;
          })}
        </div>
      </div>
      <div className={styles["action-button"]}>
        <div
          className={styles["more-information"]}
          onClick={() => onGetInformation(unit.name, unit.id)}
        >
          <Popover
            content={"Click here to view detailed information about the Unit"}
          >
            {IconPack.unit_info}
          </Popover>
        </div>
        {/* <div
          className={styles["sub-unit"]}
          onClick={() => onClickUnit(unit.name, unit.id)}
        >
          <Popover content={"Click here to view the Sub-units"}>
            {IconPack.navigation}
          </Popover>
        </div> */}
      </div>
    </div>
  );
};

export default UnitCard;
